export enum RecordStateEnum {
  ALL = "",
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}
